import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import Logo from "../../components/site/Logo";
import { useAuth, formatApiErrorDetail } from "../../context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#111827] flex items-center justify-center px-5">
      <div className="w-full max-w-sm bg-white rounded-sm p-8 border-t-4 border-espana-red">
        <div className="flex justify-center mb-6">
          <Logo />
        </div>
        <h1 className="text-xl font-black text-center mb-1">Acceso privado</h1>
        <p className="text-sm text-gray-500 text-center mb-6">
          Bandeja de mensajes de E²
        </p>
        <form onSubmit={submit} data-testid="login-form" className="space-y-4">
          <div>
            <label className="block text-sm font-bold mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="w-full border border-gray-300 rounded-sm px-4 py-3 focus:outline-none focus:ring-1 focus:ring-espana-red focus:border-espana-red transition-colors"
            />
          </div>
          <div>
            <label className="block text-sm font-bold mb-2">Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="w-full border border-gray-300 rounded-sm px-4 py-3 focus:outline-none focus:ring-1 focus:ring-espana-red focus:border-espana-red transition-colors"
            />
          </div>
          {error && (
            <p data-testid="login-error" className="text-sm text-espana-red font-medium">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full inline-flex items-center justify-center gap-2 bg-espana-red hover:bg-espana-reddark disabled:opacity-60 text-white font-bold px-6 py-3 rounded-sm transition-colors"
          >
            {loading ? <Loader2 size={18} className="animate-spin" /> : <Lock size={18} />}
            Entrar
          </button>
        </form>
      </div>
    </div>
  );
}
